// extracted by mini-css-extract-plugin
export default {"wrapper":"W_CapsuleCreators_wrapper__nARyf","text":"W_CapsuleCreators_text__5W4Rz","link":"W_CapsuleCreators_link__rKuMC"};